(function ($) {
  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for desktop
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(min-width: 1140px)", function () {
    
    ////////////////////////////////////////////////////////////////////////////////////
    // Dropdown hover
    ////////////////////////////////////////////////////////////////////////////////////
    $('.navbar-nav li.dropdown').hover(function() {
      $(this).find('.dropdown-menu').stop(true, true).delay(200).addClass('show').attr('data-bs-popper', 'static');
    }, function() {
      $(this).find('.dropdown-menu').stop(true, true).delay(200).removeClass('show').removeAttr('data-bs-popper');
    });

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for mobile
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(max-width: 1140px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Common JS - All Pages
  ////////////////////////////////////////////////////////////////////////////////////
  var Sage = {
    common: {
      init: function () {

        ////////////////////////////////////////////////////////////////////////////////////
        // Sticky Scroll Nav
        ////////////////////////////////////////////////////////////////////////////////////
        nous_sticky_scroll_header();

        gsap.registerPlugin(ScrollTrigger);

        ////////////////////////////////////////////////////////////////////////////////////
        // AOS - Animate on scroll init
        ////////////////////////////////////////////////////////////////////////////////////
        AOS.init({
          startEvent: 'DOMContentLoaded', // Default event to initialize AOS
          delay: 100, // values from 0 to 3000, with step 50ms
          duration: 400, // values from 0 to 3000, with step 50ms
          easing: 'ease', // default easing for AOS animations
          once: true, // whether animation should happen only once - while scrolling down
          anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
          // Callback when an element is animated
          animatedClassName: 'aos-animate',
          useClassNames: true,
          initClassName: 'aos-init',
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Search Functionality
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-init-sitewide-search', function () {

          ////////////////////////////////////////////////////////////////////////////////////
          // Show Search
          ////////////////////////////////////////////////////////////////////////////////////
          if ($('.js-section-site-search').is(':hidden')) {
            $('body').addClass('search-active');
            
            $(this).find('.close').addClass('d-none');
            $(this).find('.open').removeClass('d-none').addClass('d-flex');

            $('.js-section-site-search').slideDown('slow', function () {
              $('#header-search').val('').focus();
            });
          } else {
            $('body').removeClass('search-active');

            $('.js-section-site-search').slideUp('slow');

            $(this).find('.close').removeClass('d-none');
            $(this).find('.open').addClass('d-none').removeClass('d-flex');
          }

          ////////////////////////////////////////////////////////////////////////////////////
          // Return False
          ////////////////////////////////////////////////////////////////////////////////////
          return false;

        });

        //////////////////////////////////////////////////////////////
        // Animate Hamburger
        //////////////////////////////////////////////////////////////
        $('.navbar-toggler').on('click', function () {
          $(this).toggleClass('active');
          $('.navbar').toggleClass('active');
          $('body').toggleClass('navbar-active');
        });

        //////////////////////////////////////////////////////////////
        // Calculate True VH
        //////////////////////////////////////////////////////////////
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        // We listen to the resize event
        window.addEventListener('resize', () => {
          // We execute the same script as before
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Contact Form Validation
        ////////////////////////////////////////////////////////////////////////////////////
        $('#js-form-contact').validate({
          rules: {
            email: {
              remote: {
                url: '/wp-admin/admin-ajax.php',
                type: "POST",
                data: {
                  'action': 'valid_email_lookup',
                  'email_value': function () {
                    return $("#email").val();
                  },
                },
              },
            },
            phone_number: {
              validPhone: true,
            },
            'checkbox_multiple': {
              required: true,
            },
            'radio_multiple': {
              required: true,
            }
          },
          highlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-invalid').removeClass('is-valid');
            $(element).parents().children('.invalid-feedback').css('display', 'block');
            $(element).parents().children('.valid-feedback').css('display', 'none');
          },
          unhighlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-valid').removeClass('is-invalid');
            $(element).parents().children('.invalid-feedback').css('display', 'none');
            $(element).parents().children('.valid-feedback').css('display', 'block');
          },
          errorPlacement: function () {
            $(this).parents('form').addClass('was-validated');
            return false;
          },
          submitHandler: function (form) {

            ////////////////////////////////////////////////////////////////////////////////////
            // Display ajax loader
            ////////////////////////////////////////////////////////////////////////////////////
            $('.js-contact-error, .js-contact-recaptcha-error, #js-form-contact').css('display', 'none');
            $('.js-contact-loader').css('display', 'block');

            ////////////////////////////////////////////////////////////////////////////////////
            // Validate reCaptcha
            ////////////////////////////////////////////////////////////////////////////////////
            generate_google_recaptcha_token('contact_form').then(function (response) {

              ////////////////////////////////////////////////////////////////////////////////////
              // reCaptcha Response
              ////////////////////////////////////////////////////////////////////////////////////
              var reCaptchaResponse = jQuery.parseJSON(response);

              ////////////////////////////////////////////////////////////////////////////////////
              // IF Invalid - Show Error
              ////////////////////////////////////////////////////////////////////////////////////
              if (reCaptchaResponse.valid == 'false') {

                ////////////////////////////////////////////////////////////////////////////////////
                // Display Error
                ////////////////////////////////////////////////////////////////////////////////////
                $('.js-contact-loader').css('display', 'none');
                $('#js-form-contact, .js-contact-recaptcha-error').css('display', 'block');

                ////////////////////////////////////////////////////////////////////////////////////
                // ELSE Success
                ////////////////////////////////////////////////////////////////////////////////////
              } else {

                ////////////////////////////////////////////////////////////////////////////////////
                // Ajax Variables
                ////////////////////////////////////////////////////////////////////////////////////
                var apiRequestError = false; // API Request Error Status

                ////////////////////////////////////////////////////////////////////////////////////
                // Mandrill Payload
                ////////////////////////////////////////////////////////////////////////////////////
                var mandrillPayload = mandrill_json_payload('#js-form-contact'); // Mandrill API Payload

                console.log(mandrillPayload);
                return false;

                ////////////////////////////////////////////////////////////////////////////////////
                // Campaign Monitor Subscriber Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var cmPayload = new Object();
                // cmPayload.customFields = {}
                // cmPayload.listID = 'a480aacea0c318f253bf9feff5d97c83';
                // cmPayload.name = $('#first_name').val() + ' ' + $('#last_name').val();
                // cmPayload.emailAddress = $('#email').val();

                // cmPayload.customFields.PhoneNumber = $('#phone_number').val();
                // cmPayload.customFields.Message = $('#message').val();
                // cmPayload.customFields.RadioOptions = $('input[name=radioexample]:checked').val();
                // cmPayload.customFields.SelectOption = $('#select_example').val();

                // cmPayload.customFields.CheckboxField = [];
                // $('[name="checkboxexample"]').each(function( index ) {
                //   if($(this).is(':checked')) {
                //     cmPayload.customFields.CheckboxField.push($(this).val());
                //   }
                // });

                ////////////////////////////////////////////////////////////////////////////////////
                // MailChimp Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var mailChimpPayload = new Object();
                // mailChimpPayload.customFields = {}
                // mailChimpPayload.listID = 'f0dddbd24e';
                // mailChimpPayload.emailAddress = $('#email').val();

                // ////////////////////////////////////////////////////////////////////////////////////
                // // MailChimp custom fields
                // ////////////////////////////////////////////////////////////////////////////////////
                // mailChimpPayload.customFields.FNAME = $('#first_name').val();
                // mailChimpPayload.customFields.LNAME = $('#last_name').val();
                // mailChimpPayload.customFields.MERGE3 = $('#phone_number').val();

                ////////////////////////////////////////////////////////////////////////////////////
                // Load call to API
                ////////////////////////////////////////////////////////////////////////////////////
                $.when(

                  //////////////////////////////////////////////////////////////////////////////////
                  // Mandrill Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  $.ajax({
                    type: "POST",
                    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mandrill/notification',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: mandrillPayload,
                    success: function (data) {

                      ////////////////////////////////////////////////////////////////////////////////////
                      // If there is an error with the Mandrill Call, display in console.
                      ////////////////////////////////////////////////////////////////////////////////////
                      if (data.status == 'error') {

                        ////////////////////////////////////////////////////////////////////////////////////
                        // Log Error
                        ////////////////////////////////////////////////////////////////////////////////////
                        console.log(data);
                        apiRequestError = true;

                      }

                    },
                  })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Campaign Monitor Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/cm/subscriber/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(cmPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // MailChimp Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mailchimp/member/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(mailChimpPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Once all api calls are complete
                  //////////////////////////////////////////////////////////////////////////////////
                ).then(function () {

                  ////////////////////////////////////////////////////////////////////////////////////
                  // Display Success / Error based on returned API
                  ////////////////////////////////////////////////////////////////////////////////////
                  if (apiRequestError == false) {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Success Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('.js-contact-success').css('display', 'block');

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Data Layer
                    ////////////////////////////////////////////////////////////////////////////////////
                    dataLayer.push({
                      'event': 'gaTriggerEvent',
                      'gaEventCategory': 'Form',
                      'gaEventAction': 'Enquiry',
                      'gaEventLabel': 'Success'
                    });

                  } else {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Error Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('#js-form-contact').css('display', 'block');
                    $('.js-contact-error').css('display', 'block');

                  }


                });


              }
            });

          } // END ELSE VALID RECAPTCHA
        }); // END GENERATE GOOGLE reCAptcha Token

        ////////////////////////////////////////////////////////////////////////////////////
        // Chosen Init
        ////////////////////////////////////////////////////////////////////////////////////
        $('body').find('select').each(function() {
          $(this).chosen();
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Popover Init
        ////////////////////////////////////////////////////////////////////////////////////
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
        const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl));

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Hotspot Map Module
        ////////////////////////////////////////////////////////////////////////////////////
        $hotspot_map_module = $('body').find('.section-flexi-hotspot-map-module');
        if ($hotspot_map_module.length > 0) {
          $map_markers = $hotspot_map_module.find('.js-map-marker');
          
          $map_markers.each(function() {
            $popover_id = $(this).data('popover-id');
            $popover_placement = $(this).data('bs-placement');
            $popover_html = $('#' + $popover_id).html();

            // Dynamically set the content
            $(this).attr('data-bs-content', $popover_html);

            // Destroy any existing popover instance
            $(this).popover('dispose');

            // Reinitialize the popover with the updated content
            $(this).popover({
              html: true,
              container: '.js-flexi-hotspot-map-module-map-content',
              trigger: 'focus',
              placement: $popover_placement,
            });

            // Add event listeners for popover show and hide
            $(this).on('show.bs.popover', function() {
              $(this).addClass('active'); // Add class when popover is shown
            });

            $(this).on('hide.bs.popover', function() {
              $(this).removeClass('active'); // Remove class when popover is hidden
            });
          });
        }

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Flip Cards Module
        ////////////////////////////////////////////////////////////////////////////////////
        // Function to handle number animation
        function nous_number_animation($numberElement) {
          const maxValue = parseInt($numberElement.data('max-value'), 10);
          let currentValue = 0;
          const duration = 2000; // Animation duration in milliseconds
          const increment = Math.ceil(maxValue / (duration / 16)); // Increment per frame (assuming ~60fps)
        
          const animate = () => {
            currentValue += increment;
            if (currentValue >= maxValue) {
              currentValue = maxValue;
              $numberElement.text(maxValue); // Update the specific element's text
            } else {
              $numberElement.text(currentValue); // Update the specific element's text
              requestAnimationFrame(animate); // Continue animation for this element
            }
          };
        
          animate(); // Start the animation for this element
        }

        $flexi_flip_cards = $('body').find('.section-flexi-flip-cards');
        if ($flexi_flip_cards.length > 0) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const $numberElements = $(entry.target).find('.js-number-animate');
                console.log($numberElements);
                
                if ($numberElements.length > 0) {
                  $numberElements.each(function () {
                    nous_number_animation($(this)); // Pass each individual element to the animation function
                  });
                }
                observer.unobserve(entry.target); // Stop observing once animation is triggered
              }
            });
          }, { threshold: 0.25 }); // Trigger when 10% of the card is visible

          $flexi_flip_cards.find('.js-card-flip').each(function () {
            observer.observe(this);
          });
        }

        ////////////////////////////////////////////////////////////////////////////////////
        // Modal - Cookie
        ////////////////////////////////////////////////////////////////////////////////////
        (function() {
          const modalElement = document.querySelector('.js-cookie-modal');
          if (!modalElement) return;

          ////////////////////////////////////////////////////////////////////////////
          // Function to set a cookie
          // @param {string} name - The name of the cookie
          // @param {string} value - The value of the cookie
          // @param {number} days - Number of days until the cookie expires
          ////////////////////////////////////////////////////////////////////////////
          function setCookie(name, value, days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            const expires = "; expires=" + date.toUTCString();
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
          }

          ////////////////////////////////////////////////////////////////////////////
          // Function to get a cookie by name
          // @param {string} name - The name of the cookie to retrieve
          // @returns {string|null} - The value of the cookie or null if not found
          ////////////////////////////////////////////////////////////////////////////
          function getCookie(name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
              let c = ca[i];
              while (c.charAt(0) === ' ') c = c.substring(1, c.length);
              if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
          }

          ////////////////////////////////////////////////////////////////////////////
          // Check if the '_nous_cookie_agree' cookie is present
          ////////////////////////////////////////////////////////////////////////////
          if (!getCookie('_nous_cookie_agree')) {
            // Show the modal with backdrop option set to static
            const modal = new bootstrap.Modal(modalElement, {
              backdrop: 'static',
              keyboard: false
            });
            modal.show();

            ////////////////////////////////////////////////////////////////////////////
            // Add 'cookie-modal-open' class to body when modal is opened
            ////////////////////////////////////////////////////////////////////////////
            modalElement.addEventListener('shown.bs.modal', function () {
              document.body.classList.add('cookie-modal-open');
            });

            ////////////////////////////////////////////////////////////////////////////
            // Remove 'cookie-modal-open' class from body when modal is closed
            ////////////////////////////////////////////////////////////////////////////
            modalElement.addEventListener('hidden.bs.modal', function () {
              document.body.classList.remove('cookie-modal-open');
            });
          }

          ////////////////////////////////////////////////////////////////////////////
          // Handle the modal close button click
          ////////////////////////////////////////////////////////////////////////////
          document.querySelectorAll('.js-modal-close').forEach(function (closeButton) {
            closeButton.addEventListener('click', function () {
              setCookie('_nous_cookie_agree', 'true', 1); // Set cookie to last for 1 day
            });
          });
        })();

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexible Content: Flip Cards Module
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_flip_cards_module();

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexible Content: Tab Mobule
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_tab_module();

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexible Content: Dynamic Selective Content Module
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_dynamic_selective_content_module();

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexible Content: Brand Carousel
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_brand_carousel_module();

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Split Column Scrollable Content
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_split_column_scrollable_content();

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: History Module
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_history_module();
      }
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Home page
    ////////////////////////////////////////////////////////////////////////////////////
    home: {
      init: function () {}
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Beekeeper Portal Login
    ////////////////////////////////////////////////////////////////////////////////////
    beekeeper_portal_register_and_login: {
      init: function () {
        $(document).ready(function() {
          var $login_form = $('body').find('form#beekeeper-loginform');
          if ($login_form.length > 0) {
            var $login_form_email = $login_form.find('input#user_login');
            var $login_form_password = $login_form.find('input#user_pass');

            $login_form_email.attr('placeholder', 'Email *');
            $login_form_password.attr('placeholder', 'Password *');
          }
        });
      }
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Beekeeper Portal
    ////////////////////////////////////////////////////////////////////////////////////
    beekeeper_portal: {
      init: function () {
        
        ////////////////////////////////////////////////////////////////////////////////////
        // Centre Menu - Scroll
        ////////////////////////////////////////////////////////////////////////////////////
        var last_scroll_position = 0;
        var section_beekeeper_nav = $('.js-section-beekeeper-nav');
        var beekeeper_nav = $('.js-beekeeper-nav');
        var nav_active_class = 'active';
        var scroll_past_class = 'scroll-past';

        if (beekeeper_nav.length > 0) {
          var beekeeper_nav_top = beekeeper_nav.offset().top;

          $(window).on('scroll', function() {
            var current_scroll_position = $(this).scrollTop();

            // Section Scroll - Watcher
            $('section').each(function () {
              var section = $(this);
              var sectionHeight = section.outerHeight();
              var sectionTop = section.offset().top;
              var sectionBottom = sectionTop + sectionHeight;
            
              // Adjust sectionTop and sectionBottom to account for the first 50% of the section
              var adjustedSectionTop = sectionTop + (sectionHeight * 0.5);
            
              var viewportTop = $(window).scrollTop();
              var viewportBottom = viewportTop + $(window).height();
            
              var nav_links_wrapper = $('body').find('.js-section-beekeeper-nav .js-beekeeper-nav');
              var nav_link = nav_links_wrapper.find('.js-beekeeper-link[href*="#' + section.data('scroll-element') + '"]');
            
              var dropdown_toggle_text = nav_links_wrapper.find('.js-dropdown-text');
            
              // Check if the first 50% of the section is in the viewport
              if (adjustedSectionTop < viewportBottom && sectionTop < viewportBottom) {
                if (nav_link.length > 0) {
                  // Remove active class from all links within nav_links_wrapper
                  nav_links_wrapper.find('.js-beekeeper-link').removeClass('active');
                  // Add active class to the current link
                  nav_link.addClass('active');
            
                  // Update dropdown_toggle_text to match the active nav_link
                  dropdown_toggle_text.text(nav_link.text());
                }
              }
            });

            // Check if beekeeper_nav is out of the viewport
            if (current_scroll_position > beekeeper_nav_top) {
              section_beekeeper_nav.addClass(scroll_past_class);
            } else {
              section_beekeeper_nav.removeClass(scroll_past_class);
            }

            // Check if user is scrolling up
            if (current_scroll_position < last_scroll_position) {
              section_beekeeper_nav.addClass(nav_active_class);
            } else {
              section_beekeeper_nav.removeClass(nav_active_class);
            }

            // Update scroll position
            last_scroll_position = current_scroll_position;
          });

          $(window).on('resize', function() {
            $('.js-beekeeper-nav .dropdown-toggle.show').each(function() {
              const dropdown = bootstrap.Dropdown.getInstance($(this).closest('.dropdown')[0]);
              if (dropdown) {
                dropdown.hide(); // Close the dropdown
              }
            });
          });
        }
        ////////////////////////////////////////////////////////////////////////////////////

      }
    },
  };

  ////////////////////////////////////////////////////////////////////////////////////
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  ////////////////////////////////////////////////////////////////////////////////////
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
